import type { ReactNode } from "react";

import { useMemo } from "react";

import { components } from "./components";
import { MarkdownContextProvider } from "./Markdown.context";
import { plugins } from "./plugins";

interface DefaultMarkdownContextProviderProps {
  children: ReactNode;
}

export const DefaultMarkdownContextProvider = ({
  children,
}: DefaultMarkdownContextProviderProps) => {
  const value = useMemo(
    () => ({
      components,
      rehypePlugins: plugins,
    }),
    [],
  );
  return (
    <MarkdownContextProvider value={value}>{children}</MarkdownContextProvider>
  );
};
